import React from 'react';
import { useI18n } from '../../i18n/LanguageContext';
import { useMedia } from '../../site/MediaProvider';
import CountUp from './CountUp';

const scrollTo = (id: string) => (e: React.MouseEvent) => {
  const el = document.getElementById(id);
  if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
};

const Hero: React.FC = () => {
  const { t } = useI18n();
  const { single } = useMedia();
  const hero = single('hero');

  return (
    <section id="hero">
      {hero && (
        <img
          className="hero-img"
          src={hero}
          alt=""
          loading="eager"
          fetchPriority="high"
          decoding="async"
          onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
        />
      )}
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className="badge badge-y">{t('hero.badge')}</div>
        <h1 className="hero-title" dangerouslySetInnerHTML={{ __html: t('hero.title') }} />
        <p className="hero-sub">{t('hero.sub')}</p>
        <div className="hero-btns">
          <a href="#products" className="btn btn-p" onClick={scrollTo('products')}>{t('hero.cta1')}</a>
          <a href="#contact" className="btn btn-g" onClick={scrollTo('contact')}>{t('hero.cta2')}</a>
        </div>
      </div>
      <div className="hero-stats">
        <div><span className="hs-num"><CountUp value={t('hero.s1n')} /></span><span className="hs-lbl">{t('hero.s1')}</span></div>
        <div><span className="hs-num"><CountUp value={t('hero.s2n')} /></span><span className="hs-lbl">{t('hero.s2')}</span></div>
        <div><span className="hs-num"><CountUp value={t('hero.s4n')} /></span><span className="hs-lbl">{t('hero.s4')}</span></div>
      </div>
    </section>
  );
};

export default Hero;
